import { render, staticRenderFns } from "./FactChecking.vue?vue&type=template&id=4ceb7ba8"
import script from "./FactChecking.vue?vue&type=script&lang=js"
export * from "./FactChecking.vue?vue&type=script&lang=js"
import style0 from "./FactChecking.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports